<template>
  <a-card :bordered="false">
    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange">

      </a-table>
    </div>
  </a-card>
</template>

<script>
  // import {JeecgListMixin} from '@/mixins/JeecgListMixin'

  export default {
    props: ['userId'],
    name: "UserTab2",
    // mixins: [JeecgListMixin],
    data() {
      return {
        queryParam: {
          userId: this.userId
        },
        description: '消费记录',
        visible: false,
        // 表头
        columns: [
          {
            title: '订单ID',
            align: "center",
            dataIndex: 'orderId'
          },
          {
            title: '用户昵称',
            align: "center",
            dataIndex: 'nickname'
          },
          {
            title: '店铺名称',
            align: "center",
            dataIndex: 'shopName'
          },
          {
            title: '商品总价',
            align: "center",
            dataIndex: 'goodsMoney'
          },
          {
            title: '支付时间',
            align: "center",
            dataIndex: 'payTime'
          }
        ],
        url: {
          list: "/user/userExtension/getConsumption",
        },
      }
    },
    computed: {},
    methods: {}
  }
</script>